import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-slate-500 font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (superAdminOnly && user.role !== "super_admin") return <Navigate to="/dashboard" replace />;
    if (adminOnly && user.role !== "admin" && user.role !== "super_admin") return <Navigate to="/dashboard" replace />;
    return children;
}
